module.exports = {
      id: "heart-white-usage",
      viewBox: "0 0 15 13",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#heart-white-usage",
      toString: function () {
        return this.url;
      }
    }